<template>
  <hc-dieuxe-update-common-dialog
    :isOpen="isOpen"
    :id="id"
    :action="HC_STATE_TO_STATE.ACTION_CODE.DIEU_XE.CAP_NHAT"
    @dialogClosed="$emit('dialogClosed')"
    @closeDialog="$emit('closeDialog')"
    @submit="submit"
  />
</template>
<script>
  import hanhchinhService from "../../../services/hanhchinhService";
  import handleRequestErrorMixin from "../../handleRequestErrorMixin";
  import CustomDialog from "../../common/custom-dialog";
  import errorMessageFilter from "../../../filters/errorMessageFilter";
  import HcDieuxeUpdateCommonDialog from "./hc-dieuxe-update-common-dialog";
  import constants from "../../../constants";

  export default {
    name: "hc-dieuxe-update-dialog",
    mixins: [handleRequestErrorMixin],
    props: ["isOpen", "id"],
    components: {
      HcDieuxeUpdateCommonDialog,
      CustomDialog
    },

    data() {
      return {
        HC_STATE_TO_STATE: constants.HC_STATE_TO_STATE
      };
    },

    methods: {
      submit(event) {
        let submitForm = event.submitForm;
        return hanhchinhService
          .updateCar(submitForm)
          .then(response => response.data)
          .then(hcCaseCommands => {
            this.$message({
              message: errorMessageFilter({
                errorCode: "hcDieuXe.updateSuccess"
              }),
              type: "success"
            });
            this.$emit("updateSuccess", {result: hcCaseCommands});
          })
          .catch(error => {
            this.commonHandleRequestError(error);
            throw error;
          });
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/views/adminstration/dieuxe/hc-dieuxe-update-dialog.vue